import { SVGInjector } from '@tanem/svg-injector';
import stickyNav from './components/sticky-nav';
import baguetteBox from 'baguettebox.js';
import balanceText from 'balance-text';

// import '/node_modules/balance-text/balancetext.js';

function injectSVG() {
  const mySVGsToInject = document.querySelectorAll('img.inject-me,.site-branding img,.site-footer__branding img,.project-logo img');
  SVGInjector(mySVGsToInject);
}

function initBalanceText() {
  balanceText('.balance-text, .balanced, h2, h3, h4, h5', { watch: true });
}

function initBaguetteBox() {
  var options = {
    captions: function (element) {
      var figcaption = element.parentElement.getElementsByTagName('figcaption')[0];
      if (figcaption) {
        return figcaption.textContent;
      }
      return false;
    }
  };
  baguetteBox.run('.wp-block-gallery', options);
  // alert('Baguette');
}

// window.addEventListener('DOMContentLoaded', (event) => {});

window.addEventListener('load', () => {
  injectSVG();
  stickyNav();
  initBalanceText();
  initBaguetteBox();
  // setInterval(initBaguetteBox, 6000); 
});